import { Box, Spacer } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useNavigation } from '@react-navigation/core'
import { useEffect } from 'react';
import { FlatList } from 'react-native'
import { Container } from '../../comps/Container'
import { RowItem } from '../../comps/RowItem'
import { SubTitle } from '../../comps/SubTitle'
import { useStores } from '../../data/store'
import { getFormattedAmount, getMaskedAadhaarNumber, getMaskedVIDNumber } from '../../util/utill'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { StatementListItem } from './StatementListItem'

export const StatementListScreen = () => {
  const { bankName, aadhaarNo, transactions, amount, vid } = useStores((root) => ({
    bankName: root.customer.bankName,
    aadhaarNo: root.customer.aadhaarNo,
    transactions: root.customer.transactions,
    amount: root.customer.amount,
    vid: root.customer.vid,
  }))

  const navigation = useNavigation()

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Mini Statement' })
  }, [navigation])

  useEffect(() => {
    nativeJSComm(nativeJSMapper.enableScreenShot)
    return () => nativeJSComm(nativeJSMapper.disableScreenshot)
  }, [])

  const renderItem = ({ item }: any) => {
    return <StatementListItem {...item} />
  }

  return (
    <>
      <Box backgroundColor={'PRIMARY'} p={16} flexDirection={'column'}>
        {aadhaarNo && (
          <RowItem
            heading="Aadhar Number"
            detail={getMaskedAadhaarNumber(aadhaarNo)}
            showDot={false}
            headingTextColor="WHITE_DIM"
            detailTextColor="GREYISH_WHITE"
          />
        )}
        {vid && (
          <RowItem
            heading="VID Number"
            detail={getMaskedVIDNumber(vid)}
            showDot={false}
            headingTextColor="WHITE_DIM"
            detailTextColor="GREYISH_WHITE"
          />
        )}
        <Spacer size={8} />
        <RowItem
          heading="Bank"
          detail={bankName}
          showDot={false}
          headingTextColor="WHITE_DIM"
          detailTextColor="GREYISH_WHITE"
        />
        {amount && (amount + '').length > 0 && (
          <>
            <Spacer size={8} />
            <RowItem
              heading="Available Balance"
              detail={getFormattedAmount(+amount)}
              showDot={false}
              headingTextColor="WHITE_DIM"
              detailTextColor="GREYISH_WHITE"
            />
          </>
        )}
      </Box>
      <Container showFooter={true} paddingHorizontal={0}>
        <SubTitle subTitle={`*showing last ${transactions.length} transactions`} />
        <Spacer size={16} />
        <FlatList
          data={transactions}
          renderItem={renderItem}
          style={{ borderTopWidth: 1, borderTopColor: defaultColors.BORDER_COLOR }}
        />
      </Container>
    </>
  )
}
